import { useTranslation } from 'react-i18next';
import { useMultiplePricesStore } from '@/hooks/useMultiplePricesStore';
import { useDetailDataStore } from '@/hooks/useDetailDataStore';
import SimpleRichText from '@/components/SimpleRichText';
import RichTextHtmlViewer from '@/components/RichTextHtmlViewer';

export default function ScreeningQuestions() {
  const { t } = useTranslation();
  const { detailData } = useDetailDataStore();
  const {
    screeningQuestions,
    updateScreeningQuestionAnswer,
    screeningQuestionsError
  } = useMultiplePricesStore();
  const orderId = detailData?.order?.id ?? '';

  if (!screeningQuestions?.length) return null;

  return (
    <div className="flex flex-col gap-3">
      <div className="justify-start text-[#0D0D0D] text-base font-semibold font-['Inter'] leading-6">
        {t('screening_questions.title', {
          defaultValue: 'Screening questions'
        })}
      </div>
      <div
        className="flex flex-col gap-3 pr-4"
        id="take-order-screening-questions"
      >
        {screeningQuestions?.map((question, index) => {
          const isEmpty = !question?.answer?.trim();
          const showError = screeningQuestionsError && isEmpty;

          return (
            <div
              className="flex flex-col gap-1.5"
              key={`${question?.question}-${index}`}
            >
              <div className="inline-flex justify-start items-start gap-0.5 min-w-0">
                <RichTextHtmlViewer
                  html={question?.question}
                  className="simple-rich-text-show-style min-w-0 flex-1 text-[#44403C] text-sm font-medium font-['DM_Sans'] leading-5"
                />
                <div className="shrink-0 justify-start text-[#EC470A] text-sm font-medium font-['DM_Sans'] leading-5">
                  *
                </div>
              </div>
              <SimpleRichText
                orderId={orderId}
                value={question?.answer ?? ''}
                saveData={(value) =>
                  updateScreeningQuestionAnswer(index, value)
                }
                placeholder={t('screening_questions.input_placeholder', {
                  defaultValue: 'Input your answer'
                })}
              />
              {showError ? (
                <div className="text-red-500 text-sm">
                  {t('screening_questions.required_error', {
                    defaultValue: 'This is a required field.'
                  })}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
}
